import {isBlank, isNotBlank} from "@/utils";

export default {
	namespaced: true,
	state: {
		reloadState: true,
		mainMenuMap: {},
		menuByLinkMap: {},
		activeMainMenuId: '',
		activeSubMenuId: '',
		openedMainMenuId: '',
	},
	mutations: {
		setReloadState(state, reloadState) {
			state.reloadState = reloadState;
			if(reloadState) {
				state.mainMenuMap = {};
				state.menuByLinkMap = {};
			}
		},
		resetMenuId(state){
			state.activeMainMenuId = '';
			state.activeSubMenuId = '';
			state.openedMainMenuId = '';
		},
		setMainMenuMap(state, mainMenuMap) {
			state.mainMenuMap = mainMenuMap;
		},
		setMenuByLinkMap(state, menuByLinkMap) {
			state.menuByLinkMap = menuByLinkMap;
		},
		toggleMainMenu(state, mainMenuId) {
			const willFoldableStatus = !state.mainMenuMap[mainMenuId].foldable;

			if(!willFoldableStatus) {
				if(isNotBlank(state.openedMainMenuId) && isNotBlank(state.activeMainMenuId) && state.openedMainMenuId !== state.activeMainMenuId) {
					state.mainMenuMap[state.openedMainMenuId].foldable = true;
				}
			}

			state.mainMenuMap[mainMenuId].foldable = willFoldableStatus;
			state.openedMainMenuId = mainMenuId;
		},
		activeMainMenu(state, mainMenuId) {
			if(state.mainMenuMap[mainMenuId] !== undefined) {
				if(isNotBlank(state.openedMainMenuId) && mainMenuId !== state.openedMainMenuId) state.mainMenuMap[state.openedMainMenuId].foldable = true;
				if(isNotBlank(state.activeMainMenuId)) {
					if(mainMenuId !== state.activeMainMenuId) state.mainMenuMap[state.activeMainMenuId].foldable = true;
					if(isNotBlank(state.activeSubMenuId)) state.mainMenuMap[state.activeMainMenuId].subMenuMap[state.activeSubMenuId].active = false;
				}
				state.mainMenuMap[mainMenuId].foldable = false;

				state.openedMainMenuId = mainMenuId;
				state.activeMainMenuId = mainMenuId;
				state.activeSubMenuId = '';
			}

		},
		activeSubMenu(state, {mainMenuId, subMenuId}) {
			if(isNotBlank(state.activeMainMenuId)) {
				if(mainMenuId !== state.activeMainMenuId) state.mainMenuMap[state.activeMainMenuId].foldable = true;
				if(isNotBlank(state.activeSubMenuId)) state.mainMenuMap[state.activeMainMenuId].subMenuMap[state.activeSubMenuId].active = false;
			}
			state.mainMenuMap[mainMenuId].subMenuMap[subMenuId].active = true;
			if(state.mainMenuMap[mainMenuId].subMenuMap[subMenuId].tabMap.menuIdOrder.length > 0) {
				state.mainMenuMap[mainMenuId].subMenuMap[subMenuId].tabMap.menuIdOrder.forEach((tabId, idx) => {
					state.mainMenuMap[mainMenuId].subMenuMap[subMenuId].tabMap[tabId].active = idx === 0;
				})
			}

			state.activeMainMenuId = mainMenuId;
			state.activeSubMenuId = subMenuId;
		},
		activeTab(state, {mainMenuId, subMenuId, tabId}) {
			state.mainMenuMap[mainMenuId].subMenuMap[subMenuId].tabMap.menuIdOrder.forEach(id => {
				state.mainMenuMap[mainMenuId].subMenuMap[subMenuId].tabMap[id].active = id === tabId;
			})
		},
		pageInit(state, link) {
			let menuInfo = state.menuByLinkMap[link];
			if(menuInfo !== undefined) {
				if(isBlank(menuInfo.subMenuId) && isBlank(menuInfo.tabId)) this.commit('menu/activeMainMenu', menuInfo.mainMenuId);
				else {
					if(menuInfo.mainMenuId !== state.activeMainMenuId) this.commit('menu/toggleMainMenu', menuInfo.mainMenuId);
					if(isNotBlank(menuInfo.subMenuId) && menuInfo.subMenuId !== state.activeSubMenuId) this.commit('menu/activeSubMenu', { mainMenuId: menuInfo.mainMenuId, subMenuId: menuInfo.subMenuId });
					if(isNotBlank(menuInfo.tabId)) this.commit('menu/activeTab', { mainMenuId: menuInfo.mainMenuId, subMenuId: menuInfo.subMenuId, tabId: menuInfo.tabId });
				}
			}
		},
	},
	getters: {
		getReloadState(state) {
			return state.reloadState;
		},
		getMainMenuMap(state) {
			return state.mainMenuMap;
		},
		getMainMenu: (state) => (mainMenuId) => {
			return state.mainMenuMap[mainMenuId];
		},
		getSubMenuMap: (state) => (mainMenuId) => {
			return state.mainMenuMap[mainMenuId].subMenuMap;
		},
		getSubMenu: (state) => (mainMenuId, subMenuId) => {
			return state.mainMenuMap[mainMenuId].subMenuMap[subMenuId];
		},
		getTabMap: (state) => (mainMenuId, subMenuId) => {
			return state.mainMenuMap[mainMenuId].subMenuMap[subMenuId].tabMap;
		},
		getTab: (state) => (mainMenuId, subMenuId, tabId) => {
			return state.mainMenuMap[mainMenuId].subMenuMap[subMenuId].tabMap[tabId];
		},
		checkPermitMenu: (state) => (link) => {
			return state.menuByLinkMap[link] !== undefined;
		},
		getPermitByMenu: (state) => (link) => {
			return state.menuByLinkMap[link];
		}
	}
	,
};
